import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    defaultPageSize,
    pageSizeOptions,
    showSizeChanger,
    AsumsiIcon,
    IColumnProps, Table, Tooltip, Confirm
} from 'asumsi-components';

export default function (props: any) {
    const { dataSource, metaData, onTableChange, loading } = props;
    const [showConfirmation, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(false);

    const showConfirm = async (e: any) => {
        e.preventDefault();
        setDeleteId(e.target.id);
        setShowConfirm(true);
    };

    const columns: IColumnProps[] = [
        {
            dataIndex: 'title',
            key: 'title',
            title: 'Title',
            sorter: true,
        },
        {
            dataIndex: 'slug',
            key: 'slug',
            title: 'Slug',
            sorter: true,
        },
        {
            dataIndex: 'desc',
            key: 'desc',
            title: 'Description'
        },
        {
            dataIndex: 'action',
            key: 'action',
            render: (text: string, record: any) => {
                return (
                    <div className="bt-table__action">
                        <Tooltip text="edit">
                            <Link to={`/settings/statics/form/${record.id}`} style={{ marginRight: "8px" }}>
                                <AsumsiIcon icon="annotation" />
                            </Link>
                        </Tooltip>
                        <Tooltip text="hapus">
                            <Link to="" style={{ marginRight: "5px" }}>
                                <AsumsiIcon id={record.id} onClick={showConfirm} icon="trash" />
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
            columnWidht: "8%",
            title: 'Action',
        },
    ];

    return (
        <Fragment>
            <Table columns={columns}
                dataSource={dataSource}
                className="asumsi-table"
                loading={loading}
                pagination={{
                    currentPage: metaData ? metaData.page : 1,
                    defaultPageSize: metaData ? metaData.limit : defaultPageSize,
                    pageSizeOptions,
                    showSizeChanger,
                    total: metaData ? metaData.totalRecords : 0,
                }}
                rowKey="id"
                onChange={onTableChange}
                upperCaseTitle={true}
            ></Table>
            <Confirm
                loading={loading}
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    await props.deleteData(deleteId);
                    props.fetchDataList();
                }}
                content='Are you sure you want to delete this item?'
                title='Konfirmasi'
                okText='Delete'
            />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/statics/libraries/table.tsx